<template>
    <v-container flat>
        <v-row
            no-gutters
            v-if="
                (accountingPeriodsSuiteErrors && accountingPeriodsSuiteErrors.length) ||
                (missingAccountingPeriodLaps && missingAccountingPeriodLaps.length)
            "
            class="d-flex justify-center"
        >
            <v-col
                :cols="$vuetify.display.mobile ? '12' : '8'"
                v-for="(suiteError, index) in accountingPeriodsSuiteErrors"
                :key="index"
            >
                <v-card class="default_card ma-0" elevation="0" pa-0 style="margin: 5px">
                    <!-- @click="openAccountingPeriod(ap)" -->
                    <v-row class="d-flex align-center" no-gutters>
                        <!-- ** icon -->
                        <v-col
                            cols="1"
                            class="d-flex justify-center align-center"
                            v-if="!$vuetify.display.mobile"
                        >
                            <v-icon color="red" size="x-large"> $alert </v-icon>
                        </v-col>

                        <v-col cols="1" class="d-flex justify-center align-center"> </v-col>

                        <!-- ** dates -->
                        <v-col :cols="$vuetify.display.mobile ? '8' : '7'">
                            <v-row no-gutters>
                                <v-col cols="12" class="d-flex align-center justify-start">
                                    <span
                                        :class="$vuetify.display.mobile ? 'ml-2' : ''"
                                        style="font-weight: bold; font-size: 16pt; color: red"
                                    >
                                        {{ formatDate(suiteError.end) }}
                                    </span>
                                </v-col>
                            </v-row>

                            <v-row no-gutters>
                                <v-col cols="12" class="d-flex align-center justify-start">
                                    <strong class="text-red">
                                        Fin d'exercice chevauchant le début du suivant</strong
                                    >
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="1" class="d-flex justify-center align-center"> </v-col>

                        <v-col cols="1" class="d-flex justify-center align-center"> </v-col>

                        <v-col cols="1" class="d-flex justify-center align-center">
                            <v-tooltip
                                location="bottom"
                                text="Si les 2 périodes concernées sont vérrouillées, veuillez contacter le support."
                            >
                                <template v-slot:activator="{ props }">
                                    <v-btn-icon v-bind="props" icon="$oss-help" color="red" />
                                </template>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";

import { Vue, toNative } from "vue-facing-decorator";
import { Prop, Component } from "vue-facing-decorator";

@Component
export class AccountingPeriodsSuiteErrors extends Vue {
    @Prop({ default: null }) accountingPeriodsSuiteErrors: Array<any>;

    formatDate(date) {
        if (!date) return null;
        return moment(date).format("DD MMMM YYYY");
    }
}

export default toNative(AccountingPeriodsSuiteErrors);
</script>
